const dataURLs = [
  `${process.env.PUBLIC_URL}/data/hhs-data.json`,
  `${process.env.PUBLIC_URL}/data/hhs.geo.json`,
];

export const getCouncilData = () =>
  fetch(dataURLs[0]).then(response => response.json());

export const getQldCouncilGeo = () =>
  fetch(dataURLs[1]).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/index.js